import { Actions } from "../actions";
import { Store } from ".";

// update log
// FB 4371 DK    03/29/2021    Added page to handle actions and state dispatch

export default function reducer(state: Store, action: Actions) {
  switch (action.type) {
    case "MODIFY_APPOINTMENT_DETAILS":
      return { ...state, appointmentdetails: action.data };

    case "GET_PROVIDERS":
      return { ...state, providers: action.data };

    case "GET_FACILITIES":
      return { ...state, facilities: action.data };

    case "GET_STATES":
      return { ...state, states: action.data };

    case "MODIFY_SLOT_DETAILS":
      return { ...state, slotDetails: action.data };

    default:
      return state;
  }
}
